import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { loadingBoxStyles, CIRCULAR_PROGRESS_SIZES } from '../../../constants/escalateQueryDialog';

/**
 * LoadingDisplay Component
 * Shows loading spinner while fetching escalation options
 */
const LoadingDisplay = () => {
  return (
    <Box sx={loadingBoxStyles}>
      <CircularProgress size={CIRCULAR_PROGRESS_SIZES.LOADING} />
    </Box>
  );
};

export default LoadingDisplay;
